class Popup {

    element: HTMLElement

    constructor(selector) {
        this.element = document.querySelector(selector)

        if (this.element === null) {
            return;
        }

        Array.from(this.element.querySelectorAll('[data-dissmiss]')).forEach(button => {
            button.addEventListener('click', this.close.bind(this))
        })
    }

    open() {
        this.element.classList.add('opened')
        document.body.classList.add('overflow-hidden')
    }

    close() {
        this.element.classList.remove('opened')
        document.body.classList.remove('overflow-hidden')
    }
}


export default Popup;
